export default __webpack_public_path__ + "static/media/laundry1-afterA-480w.2344b9b2.webp";